import React from 'react';
import { Button, Icon } from 'antd';
import SelectPeriod from './components/SelectPeriod/SelectPeriod';
import SelectTypes from './components/SelectTypes/SelectTypes';
import SelectCompanies from './components/SelectCompanies/SelectCompanies';
import SelectStreets from './components/SelectStreets/SelectStreets';
import SelectHouses from './components/SelectHouses/SelectHouses';
import SelectAddresses from './components/SelectAddresses/SelectAddresses';
import OnlyActiveCheckbox from './components/OnlyActiveCheckbox/OnlyActiveCheckbox';
import styles from './Filter.module.scss';

export const rows = [
  // period, types
  {
    gutter: 16,
    children: [
      {
        span: 12,
        render: () => <SelectPeriod />,
      },
      {
        span: 12,
        render: () => <SelectTypes className={styles.full} />,
      },
    ],
  },

  // companies
  {
    gutter: 16,
    children: [
      {
        span: 12,
        render: ({ showCompanies }) =>
          showCompanies ? <SelectCompanies className={styles.full} /> : null,
      },
    ],
  },

  // streets, houses, addresses
  {
    inputGroup: true,
    children: [
      {
        span: 12,
        render: () => <SelectStreets className={styles.full} />,
      },
      {
        span: 6,
        render: () => <SelectHouses className={styles.full} />,
      },
      {
        span: 6,
        render: () => <SelectAddresses className={styles.full} />,
      },
    ],
  },

  // onlyActive
  {
    children: [
      {
        render: () => <OnlyActiveCheckbox />,
      },
    ],
  },

  // reset
  {
    children: [
      {
        span: 10,
        offset: 14,
        render: ({ onReset }) => (
          <Button className={styles.resetBtn} onClick={onReset}>
            <Icon type="sync" className={styles.resetFilterIcon} />
            Сбросить фильтр
          </Button>
        ),
      },
    ],
  },
];
